import {Locale} from '@aboutyou/config';
import {IconName} from '../../../atoms/Icon/IconName';
import {LogoIconName} from '../assets';

interface AboutYouAnniversaryLogo {
  logo: {iconName: IconName; ratio: `${number}/${number}`};
  // contains both the ay anniversary logo and the AboutYou logo
  fullLogo: {iconName: IconName};
}

export const AY_ANNIVERSARY_LOGO_MAP: Partial<
  Record<Locale, AboutYouAnniversaryLogo>
> = {
  [Locale.bg_BG]: {
    logo: {
      iconName: LogoIconName.AY10_bg_BG,
      ratio: '1.27/0.27',
    },
    fullLogo: {iconName: LogoIconName.AY10F_bg_BG},
  },
  [Locale.cs_CZ]: {
    logo: {iconName: LogoIconName.AY10_CZ_SI, ratio: '1.5/0.5'},
    fullLogo: {iconName: LogoIconName.AY10F_CZ_SI},
  },
  [Locale.da_DK]: {
    logo: {iconName: LogoIconName.AY10_da_DK, ratio: '2.1/1.1'},
    fullLogo: {iconName: LogoIconName.AY10F_da_DK},
  },
  [Locale.de_AT]: {
    logo: {
      iconName: LogoIconName.AY10_de_DE,
      ratio: '1.23/0.23',
    },
    fullLogo: {iconName: LogoIconName.AY10F_de_DE},
  },
  [Locale.de_CH]: {
    logo: {
      iconName: LogoIconName.AY10_de_DE,
      ratio: '1.23/0.23',
    },
    fullLogo: {iconName: LogoIconName.AY10F_de_DE},
  },
  [Locale.de_DE]: {
    logo: {
      iconName: LogoIconName.AY10_de_DE,
      ratio: '1.23/0.23',
    },
    fullLogo: {iconName: LogoIconName.AY10F_de_DE},
  },
  [Locale.el_CY]: {
    logo: {
      iconName: LogoIconName.AY10_GR_CY,
      ratio: '1.24/0.24',
    },
    fullLogo: {iconName: LogoIconName.AY10F_GR_CY},
  },
  [Locale.el_GR]: {
    logo: {
      iconName: LogoIconName.AY10_GR_CY,
      ratio: '1.24/0.24',
    },
    fullLogo: {iconName: LogoIconName.AY10F_GR_CY},
  },
  [Locale.en_DE]: {
    logo: {
      iconName: LogoIconName.AY10_en_ZZ,
      ratio: '1.26/0.26',
    },
    fullLogo: {iconName: LogoIconName.AY10F_en_ZZ},
  },
  [Locale.en_ZZ]: {
    logo: {
      iconName: LogoIconName.AY10_en_ZZ,
      ratio: '1.26/0.26',
    },
    fullLogo: {iconName: LogoIconName.AY10F_en_ZZ},
  },
  [Locale.es_ES]: {
    logo: {
      iconName: LogoIconName.AY10_es_ES,
      ratio: '1.46/0.46',
    },
    fullLogo: {iconName: LogoIconName.AY10F_es_ES},
  },
  [Locale.es_ZZ]: {
    logo: {
      iconName: LogoIconName.AY10_es_ZZ,
      ratio: '1.38/0.38',
    },
    fullLogo: {iconName: LogoIconName.AY10F_es_ZZ},
  },
  [Locale.et_EE]: {
    logo: {
      iconName: LogoIconName.AY10_et_EE,
      ratio: '1.25/0.25',
    },
    fullLogo: {iconName: LogoIconName.AY10F_et_EE},
  },
  [Locale.fi_FI]: {
    logo: {
      iconName: LogoIconName.AY10_fi_FI,
      ratio: '1.24/0.24',
    },
    fullLogo: {iconName: LogoIconName.AY10F_fi_FI},
  },
  [Locale.fr_BE]: {
    logo: {
      iconName: LogoIconName.AY10_fr_BE_CH_LU,
      ratio: '1.27/0.27',
    },
    fullLogo: {iconName: LogoIconName.AY10F_fr_BE_CH_LU},
  },
  [Locale.fr_CH]: {
    logo: {
      iconName: LogoIconName.AY10_fr_BE_CH_LU,
      ratio: '1.27/0.27',
    },
    fullLogo: {iconName: LogoIconName.AY10F_fr_BE_CH_LU},
  },
  [Locale.fr_FR]: {
    logo: {iconName: LogoIconName.AY10_fr_FR, ratio: '1.3/0.3'},
    fullLogo: {iconName: LogoIconName.AY10F_fr_FR},
  },
  [Locale.hr_HR]: {
    logo: {
      iconName: LogoIconName.AY10_hr_HR,
      ratio: '1.24/0.24',
    },
    fullLogo: {iconName: LogoIconName.AY10F_hr_HR},
  },
  [Locale.hu_HU]: {
    logo: {
      iconName: LogoIconName.AY10_hu_HU,
      ratio: '2.05/1.05',
    },
    fullLogo: {iconName: LogoIconName.AY10F_hu_HU},
  },
  [Locale.it_CH]: {
    logo: {
      iconName: LogoIconName.AY10_it_CH,
      ratio: '1.31/0.31',
    },
    fullLogo: {iconName: LogoIconName.AY10F_it_CH},
  },
  [Locale.it_IT]: {
    logo: {
      iconName: LogoIconName.AY10_it_IT,
      ratio: '1.37/0.37',
    },
    fullLogo: {iconName: LogoIconName.AY10F_it_IT},
  },
  [Locale.lt_LT]: {
    logo: {
      iconName: LogoIconName.AY10_lt_LT,
      ratio: '1.29/0.29',
    },
    fullLogo: {iconName: LogoIconName.AY10F_lt_LT},
  },
  [Locale.fr_LU]: {
    logo: {
      iconName: LogoIconName.AY10_fr_BE_CH_LU,
      ratio: '1.27/0.27',
    },
    fullLogo: {iconName: LogoIconName.AY10F_fr_BE_CH_LU},
  },
  [Locale.lv_LV]: {
    logo: {
      iconName: LogoIconName.AY10_lv_LV,
      ratio: '1.38/0.38',
    },
    fullLogo: {iconName: LogoIconName.AY10F_lv_LV},
  },
  [Locale.nl_BE]: {
    logo: {
      iconName: LogoIconName.AY10_nl_BE_NL,
      ratio: '1.28/0.28',
    },
    fullLogo: {iconName: LogoIconName.AY10F_nl_BE_NL},
  },
  [Locale.nl_NL]: {
    logo: {
      iconName: LogoIconName.AY10_nl_BE_NL,
      ratio: '1.28/0.28',
    },
    fullLogo: {iconName: LogoIconName.AY10F_nl_BE_NL},
  },
  [Locale.pl_PL]: {
    logo: {
      iconName: LogoIconName.AY10_pl_PL,
      ratio: '1.49/0.49',
    },
    fullLogo: {iconName: LogoIconName.AY10F_pl_PL},
  },
  [Locale.pt_PT]: {
    logo: {
      iconName: LogoIconName.AY10_pt_PT,
      ratio: '1.34/0.34',
    },
    fullLogo: {iconName: LogoIconName.AY10F_pt_PT},
  },
  [Locale.ro_RO]: {
    logo: {
      iconName: LogoIconName.AY10_ro_RO,
      ratio: '1.53/0.53',
    },
    fullLogo: {iconName: LogoIconName.AY10F_ro_RO},
  },
  [Locale.ru_EE]: {
    logo: {
      iconName: LogoIconName.AY10_LV_EE,
      ratio: '1.45/0.45',
    },
    fullLogo: {iconName: LogoIconName.AY10F_LV_EE},
  },
  [Locale.ru_LV]: {
    logo: {
      iconName: LogoIconName.AY10_LV_EE,
      ratio: '1.45/0.45',
    },
    fullLogo: {iconName: LogoIconName.AY10F_LV_EE},
  },
  [Locale.sk_SK]: {
    logo: {
      iconName: LogoIconName.AY10_sk_SK,
      ratio: '1.26/0.26',
    },
    fullLogo: {iconName: LogoIconName.AY10F_sk_SK},
  },
  [Locale.sl_SI]: {
    logo: {iconName: LogoIconName.AY10_CZ_SI, ratio: '1.5/0.5'},
    fullLogo: {iconName: LogoIconName.AY10F_CZ_SI},
  },
  [Locale.sv_SE]: {
    logo: {iconName: LogoIconName.AY10_sv_SE, ratio: '2.1/1.1'},
    fullLogo: {iconName: LogoIconName.AY10F_sv_SE},
  },
};
